export const GET_BOOKING_INFO_LOADING = 'REDUX_SAGA_GET_BOOKING_INFO_LOADING';
export const BOOKING_DATA_SUCCESS = 'REDUX_SAGA_BOOKING_DATA_SUCCESS';
export const BOOKING_DATA_ERROR = 'REDUX_SAGA_BOOKING_DATA_ERROR';
export const BOOKING_DATA_RESET = 'REDUX_SAGA_BOOKING_DATA_RESET';
export const BOOKING_DATA_UPDATE_QUANTITY = 'REDUX_SAGA_BOOKING_DATA_UPDATE_QUANTITY';

export const actionGetBooking = (dispatch, bookingID, email, lastName) => {
    dispatch({ type: GET_BOOKING_INFO_LOADING, payload: { bookingID: bookingID, email: email, lastName: lastName } });
};

export const actionResetBooking = (dispatch) => {
    dispatch({ type: BOOKING_DATA_RESET })
};

export const actionUpdateQuantity = (dispatch, prodID, quantity) => {
    dispatch({ type: BOOKING_DATA_UPDATE_QUANTITY, payload: { prodID: prodID, quantity: quantity } })
}